const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "";

function ensureApiBaseUrl() {
  if (!API_BASE_URL) {
    throw new Error("VITE_API_BASE_URL is not configured.");
  }
}

export async function askQuestion(payload) {
  ensureApiBaseUrl();

  const response = await fetch(`${API_BASE_URL}/v2/ask`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message = data?.error?.message ?? `Request failed with ${response.status}`;
    throw new Error(message);
  }

  return data;
}

export async function uploadDocument(payload) {
  ensureApiBaseUrl();

  const response = await fetch(`${API_BASE_URL}/upload`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message = data?.error?.message ?? `Request failed with ${response.status}`;
    throw new Error(message);
  }

  return data;
}

export async function sendFeedback(payload) {
  ensureApiBaseUrl();

  const response = await fetch(`${API_BASE_URL}/feedback`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message = data?.error?.message ?? `Request failed with ${response.status}`;
    throw new Error(message);
  }

  return data;
}
